<template>
  <div class="wrap">
    <v-card-title style="margin-left: 30px; margin-top: 40px">
      <h4 style="margin-top: 10px">Channel Report</h4>
    </v-card-title>
    <div class="row">
      <v-flex xs6>
        <v-text-field
          style="margin-left: 50px"
          v-model="search"
          append-icon="search"
          label="Search"
        ></v-text-field>
      </v-flex>
      <div class="mxauto" style="margin-left: 500px">
        <div class="d-flex justify-content-end">
          <v-btn color="primary" href="#/channelmaster" align:right
            >Create Channel</v-btn
          >
        </div>
      </div>
    </div>
    <div style="margin: 10px">
      <v-data-table
        :headers="columns"
        :loading="loading"
        :items="channelMasters"
        :search="search"
      >
        <template v-slot:top>
          <v-dialog v-model="dialog" max-width="500px">
            <v-card>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.channelName"
                        label="Channel Name"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.channelType"
                        label="Channel Type"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.broadcaster"
                        label="Broadcaster"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.imageLink"
                        label="Image link"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.status"
                        label="status"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>

        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)"> edit </v-icon>
          <v-icon small @click="deleteItem(item)"> delete </v-icon>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { channelmaster } from "@/services/channelmaster";
// import { channelmasterdelete } from "@/services/channelmaster";

export default {
  data() {
    return {
      search: "",
      loading: true,
      dialog: false,
      columns: [
        {
          text: "Channel Name",
          value: "channelName",
        },
        {
          text: "Channel Type",
          value: "channelType",
        },
        {
          text: "Broadcaster",
          value: "broadcaster",
        },
        {
          text: "Image link",
          value: "imageLink",
        },
        {
          text: "status",
          value: "status",
        },
        {
          text: "Actions",
          value: "action",
        },
      ],

      channelMasters: [],

      editedIndex: -1,
      editedItem: {
        channelName: "",
        channelType: 0,
        broadcaster: 0,
        imageLink: 0,
        status: 0,
      },
      defaultItem: {
        channelName: "",
        channelType: 0,
        broadcaster: 0,
        imageLink: 0,
        status: 0,
      },
    };
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    async demo() {
      axios
        .get("https://test.bripl.in/v1/api/channelMasters/?size=1000")
        .then((response) => {
          this.channelMasters = response.data._embedded.channelMasters;
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },

    editItem(item) {
      this.editedIndex = this.channelMasters.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      const index = this.channelMasters.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.channelMasters.splice(index, 1);

      axios
        .delete("https://test.bripl.in/v1/api/channelMasters/" + item.id)
        .then((response) => {
          console.log(response);
        });
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        axios.put(
          "https://test.bripl.in/v1/api/channelMasters/" +
            this.editedItem.id,
          {
            channelName: this.editedItem.channelName,
            channelType: this.editedItem.channelType,
            broadcaster: this.editedItem.broadcaster,
            imageLink: this.editedItem.imageLink,
            status: this.editedItem.status,
          }
        );

        Object.assign(this.channelMasters[this.editedIndex], this.editedItem);
      } else {
        axios
          .post("/channelmaster", {
            channelName: this.editedItem.channelName,
            channelType: this.editedItem.channelType,
            broadcaster: this.editedItem.broadcaster,
            imageLink: this.editedItem.imageLink,
            status: this.editedItem.status,
          })
          .then((response) => {
            console.log(response);
          });

        this.channelMasters.push(editedItem);
      }
      this.close();
    },
  },
  async mounted() {
    this.demo();
  },
};
</script>
